// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","filled":"Button_filled__gVBq8","filledLoading":"Button_filledLoading__U+9Qd","content":"Button_content__JvV2b","label":"Button_label__SeeRA"};